// import DevTools from './components/devTools';
import React, { Component } from 'react';
import Spinner from './components/spinner';

import { ActionCreators } from './actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { routes } from './config/routes';
import { RouteWithSubRoutes } from './components/subrouter';

class AppContainer extends Component {
    // _renderDevTools() {
    //     if (process.env.NODE_ENV === 'development')
    //         return <DevTools />;
    //     return;
    // }

    componentWillMount(){
        if(this.props.location.pathname === "/"){
            this.props.push("/job/open");
        }

        if(this.props.isLoggedin) this.props.push("/aoc/home");
    }

    render() {
        return (
            <div>
                { this.props.loadState && <Spinner size={40} /> }
                { routes.map((route, i) => <RouteWithSubRoutes key={i} {...route} />) }
                {/* { this._renderDevTools() } */}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loggedinUser: state.loggedinUser,
        isLoggedin: state.isLoggedin,
        loadState: state.loadState
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppContainer));


// WEBPACK FOOTER //
// ./src/container.js